import styles from 'styles/add/Progress.module.css'

const Progress = ({ progress }) =>
    <progress className={styles.bar} max="100" value={progress} style={{ width: '100%' }} />

export default Progress